import { atom } from "nanostores";

import { getWorkflowRawData } from "../../api";
import { createApiStore } from "../api-store";

/**
 * Store containing the ID of the current graph query
 */
export const $workflowID = atom<null | string>(null);

/**
 * Store containing the result of the current graph query
 */
export const $workflow = createApiStore(getWorkflowRawData, {
  mapToOptions: ([id]) => ({
    path: {
      id: id || "",
    },
  }),
  params: [$workflowID],
  storeKey: "graphQuery",
});
